import {Component, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {Errors, ApiService} from '@common-lib';
import { map } from 'rxjs/operators';
import { ToasterService } from 'angular2-toaster';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
    email = '';
    isSubmitting = false;
    resetPassordForm: FormGroup;
    errors: Errors = {errors: {}};

    constructor(
        private api: ApiService,
        private toasterService: ToasterService,
        private translateService: TranslateService,
    ) {
    }

    ngOnInit() {
    }


    submitForm() {

        this.api.post('/auth/forgot', { email: this.email })
            // .pipe(
            //     map(response => response)
            // )
            .subscribe(
                async (res) => {
                    let successMessage = await this.translateService.get('webpanel.auth.reset_password_success').toPromise();
                    this.toasterService.pop('success', '', successMessage);
                },
                async (err) => {
                    this.toasterService.pop('danger', 'Error', err);
                }
            );



    }

    successResetPassword() {

    }

    getError(name) {
        return this.errors.errors[name] ? this.errors.errors[name] : '';
    }

}



// WEBPACK FOOTER //
// ./src/app/pages/reset-password/reset-password.component.ts